export const GET_JOBS_REQUEST = 'JobsPage/GET_JOBS_REQUEST';
export const GET_JOBS_SUCCESS = 'JobsPage/GET_JOBS_SUCCESS';
export const GET_JOBS_FAILURE = 'JobsPage/GET_JOBS_FAILURE';
